// „Zurück“-Knopf einer Seite (BUT-0059, 03.11.2026): Zurück führt nie in einen Beleg-Editor.
// Regel: Ein Ausgang aus dem Beleg ersetzt den Beleg im Verlauf und merkt sich state.ausBeleg (WysiwygDocumentEditor).
//   - location.state.zurueck (Herkunft, falls eine Seite sie mitgibt) gilt zuerst (außer es ist ein Beleg),
//   - kam man aus einem Beleg (state.ausBeleg) oder gibt es keinen vorigen Eintrag (neuer Tab, Link): feste Seite `fallback`,
//   - sonst wie der Browser: ein Schritt zurück.
// Benutzung: onClick={() => zurueckGehen(navigate, location, "/module/projekte")}
export const istBelegAdresse = (pfad) => /^\/(quotes|orders|invoices)\/(edit|new)(\/|$|\?)/.test(String(pfad || ""));

export const zurueckGehen = (navigate, location, fallback) => {
  const herkunft = location?.state?.zurueck;
  if (herkunft && !istBelegAdresse(herkunft)) { navigate(herkunft); return; }
  const keinVorheriger = typeof window !== "undefined" && (window.history.state?.idx ?? 1) === 0;
  if (location?.state?.ausBeleg || keinVorheriger) { navigate(fallback, { replace: true }); return; }
  navigate(-1);
};
